import { auth } from "db/config";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";

/**
 * Registra un nuevo usuario con email y contraseña
 * @param {string} email - El correo electrónico del usuario
 */
export const register = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    // Enviar correo de verificación al nuevo usuario
    await sendEmailVerification(auth.currentUser);
    return userCredential;
  } catch (error) {
    console.error("Error al registrar el usuario:", error);
    throw error;
  }
};
